import AuthenticatedLayout from '../../components/AuthenticatedLayout'
import { Link } from '@inertiajs/react'

function formatCurrency(amount) {
  return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(amount || 0)
}

export default function UsersShow({ user, stores }) {
  return (
    <AuthenticatedLayout>
      <div className="space-y-8">
        <div className="flex justify-between items-start">
          <div>
            <Link href="/users" className="text-sm text-indigo-600 hover:underline">← Användare</Link>
            <h1 className="text-2xl font-bold text-gray-900 mt-2">{user.name}</h1>
            <p className="text-gray-500">{user.email}</p>
            <div className="flex gap-2 mt-2">
              {user.org_admin && (
                <span className="text-xs font-medium bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full">
                  Organisationsadmin
                </span>
              )}
              {user.teams.map(t => (
                <span key={t.id} className="text-xs font-medium bg-gray-100 text-gray-600 px-2 py-0.5 rounded-full">
                  {t.name}
                </span>
              ))}
            </div>
          </div>
          <Link href={`/users/${user.id}/edit`} className="text-sm text-indigo-600 hover:underline">
            Redigera
          </Link>
        </div>

        <div>
          <h2 className="text-lg font-semibold text-gray-900 mb-3">Butiker</h2>
          <div className="bg-white rounded-xl border border-gray-200 divide-y divide-gray-100">
            {stores.length === 0 && (
              <p className="px-4 py-8 text-center text-gray-500 text-sm">Inga butiker ännu.</p>
            )}
            {stores.map(s => (
              <div key={s.id} className="flex items-center justify-between px-4 py-3">
                <p className="font-medium text-gray-900">{s.activity_name}</p>
                <div className="flex items-center gap-4">
                  <p className="text-sm text-gray-500">{s.orders_count} beställningar</p>
                  <p className="text-sm font-medium text-gray-900">{formatCurrency(s.total_sales)}</p>
                  <a
                    href={`/stores/${s.token}`}
                    target="_blank"
                    rel="noreferrer"
                    className="text-sm text-indigo-600 hover:underline"
                  >
                    Visa butik
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  )
}
